import { render, staticRenderFns } from "./recaption.vue?vue&type=template&id=56f48159&scoped=true&"
import script from "./recaption.vue?vue&type=script&lang=js&"
export * from "./recaption.vue?vue&type=script&lang=js&"
import style0 from "./recaption.vue?vue&type=style&index=0&id=56f48159&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56f48159",
  null
  
)

export default component.exports